module.exports = __webpack_public_path__ + "static/media/Checkmark.1e3226aa.svg";